module.exports = __webpack_public_path__ + "img/sloganEs.f1bad15d.svg";